export default __webpack_public_path__ + "static/media/7492-bailey.213c0d37.pdf";